import Vue from 'vue'
import Router from 'vue-router'

function templateName(path) {
	return() =>
		import(`@/components/${path}`);
}

const NotFoundComponent = templateName('error.vue');//404
const Index = templateName('index.vue')//测试
//const ThirdLogin = templateName('thirdLogin.vue')

//------------other
const AboutUs = templateName('other/aboutUs.vue');//关于我们
const Contact = templateName('other/contact.vue');//联系我们
const WebsiteMap = templateName('other/websiteMap.vue');//网站地图
const Clause = templateName('other/clause.vue');//使用条款
const Agreement = templateName('other/agreement.vue');//授权协议
const CommonProblem = templateName('other/commonproblem.vue');//常见问题
const InvoiceContract = templateName('other/invoicecontract.vue');//发票和合同

/******main*********/
//------------免费
// const Free = templateName('free/free.vue');//免费--免费专区-首页
// const FreeImage = templateName('free/freeimage.vue');//免费--免费详情
// const FreeAtlas = templateName('free/freeatlas.vue');//免费--免费图集
// const FreeSearch = templateName('free/freesearch.vue');//免费--免费搜索
// const FreeVIP = templateName('free/freevip.vue');//免费--免费vip
//------------高端
const Premium = templateName('premium/premium.vue');//高端-- 高端图片 -- 高端首页
const PremiumSearch = templateName('premium/premiumsearch.vue');//高端--高端搜索
const PremiumImage = templateName('premium/premiumimage.vue');//高端--高端详情
const PremiumAtlas = templateName('premium/premiumatlas.vue');//高端-- 高端图集

//------------相似和作者其他
const authorpicture = templateName('similarauthor/de/deauthor.vue');//de 作者其它图片 us
const OrAuthor = templateName('similarauthor/or/orauthor.vue');//or 作者其他图片
const VideoAuthor = templateName('similarauthor/video/videoauthor.vue');//de 作者其它视频 video
const GradeAuthorOther = templateName('similarauthor/grade/gradeauthorother.vue');//gd 作者其他 图片

const Similar = templateName('similarauthor/de/similar.vue');//de 图片相似 us
const DtSimilar = templateName('similarauthor/dt/dtsimilar.vue');//dt 图片相似 eu
const VideoSimilar = templateName('similarauthor/video/videosimilar.vue');//de 视频相似 video


const DeSerieModel = templateName('similarauthor/de/deseriemodel.vue');//de 视频相似 video



const DeElse = templateName('similarauthor/de/deelse.vue');//de相关页面  pic+video 的相似、作者、同组、模特








//------------音乐模块
const MusicSearch = templateName('music/musicsearch.vue');//音乐搜索
// const MusicSearch = templateName('music/musicsearchtes.vue');//音乐搜索 测试
const MusicDetail = templateName('music/musicdetail.vue');//音乐详情
//const MusicDetailTest = templateName('music/musicdetailtest.vue');//音乐详情 测试
const MusicPayment = templateName('music/musicpayment.vue');//音乐支付
const MusicAuthorOther = templateName('music/musicauthorother.vue');//音乐作者其他


//------------个人中心
const Account = templateName('usercenter/account.vue');//个人中心--首页
const Orders = templateName('usercenter/orders.vue');//个人中心--我的订单
const Downloads = templateName('usercenter/downloads.vue');//个人中心--下载记录
const Collections = templateName('usercenter/collections.vue');//个人中心--收藏夹
const Browsing = templateName('usercenter/browsing.vue');//个人中心--浏览记录
const Mypackage = templateName('usercenter/mypackage.vue');//个人中心--我的套餐
const Recharge = templateName('usercenter/recharge.vue');//个人中心--充值
const Invoice = templateName('usercenter/invoice.vue');//个人中心--发票
const InvoiceDeatil = templateName('usercenter/invoicedetail.vue');//个人中心--
const Coupon = templateName('usercenter/coupon.vue');//个人中心--优惠券
const Settings = templateName('usercenter/settings.vue');//个人中心--账户设置
const Usermessage = templateName('usercenter/usermessage.vue');//个人中心--站内信
const AccountCollectionsDetails = templateName('usercenter/collectionsdetails.vue');//个人中心--收藏夹详情

//------------
const Atlas = templateName('main/atlas.vue');//普通图集
const Video = templateName('main/video.vue');//创意视频
const Yunpai = templateName('main/yunpai.vue');//照片直播
const Price = templateName('main/price.vue');//VIP价格
const Business = templateName('main/business.vue');//升级企业版
//------------
const Payment = templateName('main/payment.vue');//付款详情
const Notorderdetail = templateName('main/notorderdetail.vue');//未支付订单
const Isorderdetail = templateName('main/isorderdetail.vue');//已支付订单
const Shopcarpay = templateName('main/shopcarpay.vue');//购物车结算

//------------
const Search = templateName('search/search_deor_0630.vue');//图片搜索

const ShoppingCart = templateName('cart/shoppingcart.vue');//购物车


Vue.use(Router)

const root = Vue.component('root', {
	template: '<router-view></router-view>'
});


const router = new Router({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	},

	routes: [{
			path: '/index',
			name: 'index',
			component: Index,
			meta: {
				hidden: true,
				type: 'main'
			}
	},
		{
			path: '*',
			name: '404',
			component: NotFoundComponent,
			meta: {
				hidden: true,
				type: 'main'
			}
		}, {
			path: '/aboutUs',
			name: '关于我们',
			component: AboutUs,
			meta: {
				hidden: true,
				type: 'main'
			}
		},
		{
			path: '/websiteMap',
			name: '网站地图',
			component: WebsiteMap,
			meta: {
				hidden: true,
				type: 'main'
			}
		}, {
			path: '/contact',
			name: '联系方式',
			component: Contact,
			meta: {
				hidden: true,
				type: 'main'
			}
		},{
			path: '/clause',
			name: '使用条款',
			component: Clause,
			meta: {
				hidden: true,
				type: 'main',
			}
		}, {
			path:'/commonproblem',
			name:'常见问题',
			component:CommonProblem,
			meta: {
				hidden: true,
				type: 'main',
			}

		}, {
			path:'/invoicecontract',
			name:'发票和合同',
			component:InvoiceContract,
			meta: {
				hidden: true,
				type: 'main',
			}

		},{
			path: '/agreement',
			name: '授权协议',
			component: Agreement,
			meta: {
				hidden: true,
				type: 'main',
			}
		},{
			path: '/shoppingcart',
			name: '购物车',
			component: ShoppingCart,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/notorderdetail',
			name: '未支付订单',
			component: Notorderdetail,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/isorderdetail',
			name: '已支付订单',
			component: Isorderdetail,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/shopcarpay',
			name: '购物车结算',
			component: Shopcarpay,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/payment',
			name: '付款详情',
			component: Payment,
			meta: {
				hidden: true,
				type: 'main',
			}
		}, {
			path: '/business',
			name: '升级企业版',
			component: Business,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		// {
		// 	path: '/free/image/:id',
		// 	name: '免费详情',
		// 	component: FreeImage,
		// 	meta: {
		// 		hidden: true,
		// 		type: 'main',
		// 	}
		// }, {
		// 	path: '/free/atlas/:id',
		// 	name: '免费图集',
		// 	component: FreeAtlas,
		// 	meta: {
		// 		hidden: true,
		// 		type: 'main',
		// 	}
		// }, {
		// 	path: '/free/search',
		// 	name: '免费搜索',
		// 	component: FreeSearch,
		// 	meta: {
		// 		hidden: true,
		// 		type: 'main',
		// 	}
		// }, {
		// 	path: '/free/vip',
		// 	name: '免费vip',
		// 	component: FreeVIP,
		// 	meta: {
		// 		hidden: true,
		// 		type: 'main',
		// 	}
		// },
		{
			path: '/search',
			name: '搜索',
			component: Search,
			meta: {
				hidden: true,
				type: 'main',
			}
		}, {
			path: '/premium/atlas/:id',
			name: '高端图集',
			component: PremiumAtlas,
			meta: {
				hidden: true,
				type: 'main',
			}
		}, {
			path: '/premium/search',
			name: '高端搜索',
			component: PremiumSearch,
			meta: {
				hidden: true,
				type: 'main',
			}
		}, {
			path: '/premium/image/:id',
			name: '高端详情',
			component: PremiumImage,
			meta: {
				hidden: true,
				type: 'main',
			}
		},{
			path: '/atlas/:id',
			name: '普通图集',
			component: Atlas,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/authorpicture/:id/:author',
			name: '作者其他图片DE',
			component: authorpicture,
			meta: {
				hidden: true,
				type: 'main',
			}
		},{
			path:'/videoauthor/:id/:author',
			name:'作者其他视频',
			component:VideoAuthor,
			meta:{
				hidden: true,
				type: 'main',
			}
		}, {
			path:'/gradeauthor/:id/:author',
			name:'高端作者其他图片',
			component:GradeAuthorOther,
			meta:{
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/similar/:id',
			name: '普通相似DE',
			component: Similar,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/videosimilar/:id',
			name: '视频相似',
			component: VideoSimilar,
			meta: {
				hidden: true,
				type: 'main',
			}
		},{
			path: '/orauthor/:id/:author',
			name: '作者其他OR',
			component: OrAuthor,
			meta: {
				hidden: true,
				type: 'main',
			}
		},{
			path: '/dtsimilar/:id',
			name: '相似图片DT',
			component: DtSimilar,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/seriemodel/:id',
			name: '同组和模特',
			component: DeSerieModel,
			meta: {
				hidden: true,
				type: 'main',
			}
		},{
			path: '/seriemodel/:id',
			name: 'US相关页面',
			component: DeElse,
			meta: {
				hidden: true,
				type: 'main',
			}
		},







		/**********音乐模块**********/
		//  MusicSearch MusicDetail MusicAuthorOther MusicPayment
		{
			path: '/musicsearch',
			name: '版权音乐',//音乐搜索
			component: MusicSearch,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/musicdetail/:id',
			name: '音乐详情',
			component: MusicDetail,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/musicauthorother/:id',
			name: '音乐作者其他',
			component: MusicAuthorOther,
			meta: {
				hidden: true,
				type: 'main',
			}
		},
		{
			path: '/musicpayment',
			name: '音乐支付',
			component: MusicPayment,
			meta: {
				hidden: true,
				type: 'main',
			}
		},


		/**********音乐模块**********/


/**********导航栏*************/

		{ //导航栏
			path: '/',
			component: root,
			meta: {
				hidden: false,
			},
			children: [
				// {
				// 	path: '/free',
				// 	name: '免费专区',
				// 	component: Free,
				// 	meta: {
				// 		hidden: false,
				// 		type: 'main'
				// 	},
				// },

				{
					path: '/premium',
					name: '高端图片',
					component: Premium,
					meta: {
						hidden: false,
						type: 'main'
					},
				},
				{
					path: '/movie',
					name: '创意视频',
					component: Video,
					meta: {
						hidden: false,
						type: 'main'
					},
				},
				{
					path: '/yunpai',
					name: '照片直播',
					component: Yunpai,
					meta: {
						hidden: false,
						type: 'main',
					},
				},
				{
					path: '/price',
					name: 'VIP价格',
					component: Price,
					meta: {
						hidden: false,
						type: 'main',
						icon: '//frontend.originoo.com/static/sites/originoo/img/hot.png',
					},
				}
			]
		},
		/**********导航栏*************/
		{
			path: '/account/collections/:id/:collectName2',
			name: '收藏夹详情',
			component: AccountCollectionsDetails,
			meta: {
				hidden: false,
				type: 'user'
			},

		},
		{
			path: '/account/invoicedetail/:id',
			name: '发票详情',
			component: InvoiceDeatil,
			meta: {
				hidden: false,
				type: 'user'
			},

		},


/********个人中心侧边**********/
		{
			path: '/',
			component: root,
			//						redirect: {
			//							path: '/account/index'
			//						},
			meta: {
				hidden: false,
			},
			children: [{
					path: '/account/index',
					name: '首页',
					component: Account,
					meta: {
						hidden: false,
						type: 'user'
					},
				}, {
					path: '/account/orders',
					name: '我的订单',
					component: Orders,
					meta: {
						hidden: false,
						type: 'user'
					},
				}, {
					path: '/',
					name: '我的图库',
					component: root,
					meta: {
						hidden: true,
					},
					children: [{
							path: '/account/downloads',
							name: '下载记录',
							component: Downloads,
							meta: {
								hidden: false,
								type: 'user'
							}
						},

						{
							path: '/account/collections',
							name: '收藏夹',
							component: Collections,
							meta: {
								hidden: false,
								type: 'user'
							}
						}, {
							path: '/account/browsing',
							name: '浏览记录',
							component: Browsing,
							meta: {
								hidden: false,
								type: 'user'
							}
						}, {
							path: '/account/mypackage',
							name: '我的套餐',
							component: Mypackage,
							meta: {
								hidden: false,
								type: 'user'
							}
						}
					]
				}, {
					path: '/',
					name: '费用中心',
					component: root,
					meta: {
						hidden: true,
					},
					children: [{
							path: '/account/recharge',
							name: '充值',
							component: Recharge,
							meta: {
								hidden: false,
								type: 'user'

							}
						},
						{
							path: '/account/invoice',
							name: '发票',
							component: Invoice,
							meta: {
								hidden: false,
								type: 'user'
							}
						},
						{
							path: '/account/coupon',
							name: '优惠券',
							component: Coupon,
							meta: {
								hidden: false,
								type: 'user'
							}
						}
					]
				}, {
					path: '/account/settings',
					name: '账户设置',
					component: Settings,
					meta: {
						hidden: false,
						type: 'user'
					},
				}, {
					path: '/account/usermessage',
					name: '站内信',
					component: Usermessage,
					meta: {
						hidden: false,
						type: 'user'
					},
				}

			]

		},
		/********个人中心侧边**********/

	]
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

router.beforeEach((to, from, next) => {
	next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js